'use client';

import { addNextjsError } from '@datadog/browser-rum-nextjs';
import { useEffect } from 'react';

import { ErrorScreen } from '@/app/_global/_components/ErrorScreen/ErrorScreen';
import { useExitToOrigin } from '@/app/_global/_hooks/useExitToOrigin';
import { reloadIfChunkLoadError } from '@/app/_global/_services/chunkLoadError.service';

interface ErrorProps {
  error: Error;
  reset: () => void;
}

/**
 * 런타임 에러 boundary. "메인으로 가기"는 hard navigate — 오염됐을 수 있는 런타임·캐시를
 * 전체 리로드로 리셋한다(/journey fallback만 SPA navigate라 reset 정상 동작에 의존).
 */
export default function Error({ error, reset }: ErrorProps) {
  const { exitToOrigin } = useExitToOrigin();

  // RUM이 이 boundary가 잡은 에러를 자동 수집하지 않으므로 명시 리포트한다.
  // 배포 직후 stale 청크 로드 실패면 화면을 띄우지 않고 최신 번들로 1회 자가복구한다.
  useEffect(
    function reportAndRecover() {
      addNextjsError(error);
      reloadIfChunkLoadError(error);
    },
    [error],
  );

  return (
    <ErrorScreen
      title="문제가 발생했어요"
      description={
        <>
          잠시 후 다시 시도해 주세요.
          <br />
          문제가 계속되면 고객센터로 문의해 주세요.
        </>
      }
      primaryAction={{ label: '다시 시도', onClick: reset }}
      secondaryAction={{ label: '메인으로 가기', onClick: exitToOrigin }}
    />
  );
}
